<template>
  <MainLayout>
    <v-container class="mt-10">
      <v-row>
        <v-breadcrumbs :items="breadcrumbs">
          <template v-slot:prepend>
            <v-icon icon="$vuetify" size="small"></v-icon>
          </template>
        </v-breadcrumbs>
        <v-divider></v-divider>
      </v-row>

      <v-row>
        <v-data-table-server
          :headers="headers"
          :items="serialnumberList"
          v-model:options="options"
          :loading="loading"
          :search="search"
          :items-per-page-options="[10, 25, 50, 100]"
          :footer-props="{
            'items-per-page-options': [10, 25, 50, 100],
            'items-per-page-text': 'Sayfa başına kayıt',
            'page-text': '{0}-{1} / {2}',
          }"
          class="elevation-1"
          @update:options="fetchSerialNumberList"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Sisteme Kayıtlı Seri Numaraları</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="serial_number"
                label="Ara..."
                class="mx-4"
                solo
                @input="fetchSerialNumberList"
                clearable
              ></v-text-field>
            </v-toolbar>
          </template>

          <template v-slot:item="{ item }">
            <tr>
              <td class="text-start" style="width: 20%">
                {{ item.serial_number }}
              </td>
              <td class="text-center" style="width: 10%">{{ item.brand }}</td>
              <td class="text-center" style="width: 10%">{{ item.model }}</td>
              <td class="text-center" style="width: 10%">{{ item.color }}</td>
              <td
                class="text-end"
                style="width: 10%; color: #f00; text-align: end"
              >
                {{ formatCurrency(item.base_price) }} ₺
              </td>
              <td
                class="text-end"
                style="width: 10%; color: #f00; text-align: end"
              >
                {{ formatCurrency(item.personal_price) }} ₺
              </td>
              <td class="text-end" style="width: 10%; color: blue;font-weight: bold; text-align: end">
                <v-text-field
                  v-if="editingPrice === item.id"
                  v-model="tempSalePrice"
                  type="number"
                  dense
                  hide-details
                  @blur="onInputBlur(item.id)"
                  @keyup.enter="onEnterPress(item.id, $event)"
                  style="width: 100px; display: inline-block"
                ></v-text-field>
                <span v-else @click="startEditing(item)" :class="{ 'highlight-update': highlightedId === item.id }">
                  {{ formatCurrency(item.selling_price) }} ₺
                </span>
              </td>

              <td class="text-center" style="width: 20%">
                <span v-if="item.device_assigned == 'default'">Hayır</span>
                <span v-if="item.device_assigned != 'default'">Evet</span>
              </td>
              <td class="text-end" style="width: 20%">
                <v-badge
                  class="w-100"
                  v-if="item.status == 'sold'"
                  color="success"
                  content="Satıldı"
                  inline
                ></v-badge>
                <div
                  v-if="item.status == 'available'"
                  style="display: flex; align-items: center"
                >
                  <v-btn
                    v-if="item.status == 'available'"
                    size="30"
                    @click="setFastSale(item.serial_number)"
                    color="success"
                    class="icon-size"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-point-of-sale</v-icon>
                  </v-btn>

                  <v-btn
                    size="30"
                    @click="deleteSerialNumber(item.id)"
                    color="orange"
                    class="icon-size ml-3"
                    icon
                  >
                    <v-icon color="white" size="20">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-row>
    </v-container>

    <v-dialog v-model="fastSale" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Hızlı Satış</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" v-if="isSerialNumberValid">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <CustomerSelect
                    v-model="newSale.selectedCustomerId"
                    label="Müşteri Ara"
                    :error-messages="isCustomerValidMessage"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <UserSelect
                    required
                    v-model="newSale.selectedUserId"
                    label="Personel Ara"
                    :error-messages="isPersonalValidMessage"
                  />
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="newSale.serialNumber"
                    label="Seri No"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="newSale.sellingPrice"
                    label="Satış Fiyatı"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="newSale.creditCard"
                    label="Kredi Kartı"
                    :error-messages="isCreditCardValidMessage"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="newSale.cash"
                    label="Nakit"
                    type="number"
                    :error-messages="isCashValidMessage"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="newSale.instalement"
                    label="Taksit"
                    min="0"
                    max="3"
                    type="number"
                    value="0"
                    @input="changeInstalement"
                    :error-messages="isInstalementValidMessage"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" v-if="instalementSetting">
                  <v-row>
                    <v-col cols="6">
                      <!-- İlk bileşen için 6 kolon genişliği -->
                      <v-checkbox
                        label="Cariye İşle"
                        v-model="newSale.isCurrent"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6">
                      <!-- İkinci bileşen için 6 kolon genişliği -->
                      <v-text-field
                        v-model="newSale.OIIUJ9U7INN"
                        label="Ödeme Tarihi"
                        type="date"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="newSale.description"
                    label="Açılama"
                    type="text"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions v-if="isSerialNumberValid">
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="makeFastSale"
            >Satışı Tamamla</v-btn
          >
          <v-btn color="grey" text @click="fastSale = false">İptal</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </MainLayout>
</template>

<script>
import { useStore } from "vuex";
import { computed, watch, ref } from "vue";
import mainService from "@/services/mainService";
import MainLayout from "@/layouts/MainLayout.vue";
import Swal from "sweetalert2"; // SweetAlert2'yi içe aktar
import CustomerSelect from "@/components/CustomerSelect.vue";
import UserSelect from "@/components/UserSelect.vue";
import serialNumberService from "@/services/serialNumberService";
export default {
  name: "SerialNumberList",
  components: {
    MainLayout,
    CustomerSelect,
    UserSelect,
  },

  data() {
    return {
      editingPrice: null,
      tempSalePrice: null,
      breadcrumbs: [
        {
          title: "Anasayfa",
          disabled: false,
          href: "pDashboard",
        },
        {
          title: "Seri Numaraları",
          disabled: false,
          href: "",
        },
      ],
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 10, // Varsayılan sayfa başına kayıt sayısı
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
      },

      headers: [
        { title: "Seri No", value: "serial_number" },
        { title: "Marka", align: "center", value: "brand" },
        { title: "Model", align: "center", value: "model" },
        { title: "Renk", value: "color" },
        { title: "Alış F.", align: "end", value: "base_price" },
        { title: "Personel F.", align: "end", value: "personal_price" },
        { title: "Satış F.", align: "end", value: "selling_price" },
        { title: "Temikli ?", align: "center", value: "device_assigned" },
        { title: "İşlemler", value: "actions", sortable: false }, // Aksiyonlar için
      ],
      select: { name: "Seçiniz", id: "0" },
      serialnumberList: [],
      loading: false, // Yükleniyor durumu
      serial_number: "", // Arama metni
      addSerialNumberDialog: false, // Kullanıcı ekleme modal durumu
      isCustomerValidMessage: "",
      isPersonalValidMessage: "",
      isCreditCardValidMessage: "",
      isCashValidMessage: "",
      isInstalementValidMessage: "",
      isSellingPriceValidMessage: "",
      fastSale: false, // Form geçerliliği
      valid: false, // Form geçerliliği
      highlightedId: null,
      rules: {
        required: (value) => !!value || "Bu alan gereklidir.",
      },
    };
  },
  setup(props, { emit }) {
    const store = useStore();

    // newSale nesnesi
    const newSale = ref({
      selectedCustomerId: null, // Başlangıçta null veya uygun bir ID değeri
      selectedUserId: null,
      serialNumber: "",
      sellingPrice: "",
      cash: "",
      creditCard: "",
      instalement: "",
      description: "",
      isCurrent: false,
      padiDate: "",
    });

    // Müşteri listesi ve kullanıcı listesi
    const customerList = computed(() => store.state.customerList);
    const userList = computed(() => store.state.userList);

    // Seçilen müşteri ID değiştiğinde işlemi izlemek
    watch(
      () => newSale.value.selectedCustomerId, // İzlenecek değişken
      (newValue, oldValue) => {
        console.log("Yeni Seçilen Müşteri ID:", newValue);
        console.log("Eski Seçilen Müşteri ID:", oldValue);
        emit("update:modelValue", newValue); // Seçilen müşteri ID'sini dışarıya ilet
      },
      { immediate: true } // Başlangıçta da çalışmasını sağlamak için
    );

    // Seçilen müşteri ID değiştiğinde işlemi izlemek
    watch(
      () => newSale.value.selectedUserId, // İzlenecek değişken
      (newValue, oldValue) => {
        console.log("Yeni Seçilen Müşteri ID:", newValue);
        console.log("Eski Seçilen Müşteri ID:", oldValue);
        emit("update:modelValue", newValue); // Seçilen müşteri ID'sini dışarıya ilet
      },
      { immediate: true } // Başlangıçta da çalışmasını sağlamak için
    );
    return {
      customerList,
      userList,
      newSale,
    };
  },
  methods: {
    onEnterPress(itemId, event) {
      event.target.blur(); // Input'u blur et (focus'u kaldır)
    },

    onInputBlur(itemId) {
      this.updateSalePrice(itemId);
    },
    startEditing(item) {
      this.editingPrice = item.id;
      this.tempSalePrice = item.sale_price;
    },

    async updateSalePrice(itemId) {
      try {
        await serialNumberService.update(`stockmovements/${itemId}`, {
          selling_price: this.tempSalePrice,
        });
        this.fetchSerialNumberList();
        this.editingPrice = null;
        this.tempSalePrice = null;

         // Highlight efekti için
         this.highlightedId = itemId;
        setTimeout(() => {
          this.highlightedId = null;
        }, 1500); // 1.5 saniye sonra highlight'ı kaldır
      } catch (error) {
        console.error("Fiyat güncellenirken hata oluştu:", error);
        Swal.fire("Hata!", "Fiyat güncellenirken bir hata oluştu.", "error");
      }
    },
    showAddSerialNumberDialog() {
      this.resetNewSerialNumber(); // Formu sıfırla
      this.addSerialNumberDialog = true; // Modalı göster
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
    resetNewSale() {
      this.newSale = {
        serialNumber: "",
        sellingPrice: "",
        selectedCustomerId: "",
        selectedUserId: "",
        cash: "",
        creditCard: "",
        instalement: "",
        descrition: "",
      };
    },
    setFastSale(serialNumber) {
      this.loading = true;

      if (!serialNumber) {
        this.isSerialNumberValidMessage = "Seri No boş bırakılamaz.";
        this.loading = false;
        return;
      }

      mainService
        .get("stockmovements", serialNumber)
        .then((response) => {
          if (response.total == 0) {
            this.isSerialNumberValidMessage =
              "Geri Seri No Giriniz... Ürün Buluanmadı";
          } else {
            this.newSale.serialNumber = response.data[0].serial_number;
            this.newSale.sellingPrice = response.data[0].selling_price;
            this.isSerialNumberValid = true;
            this.fastSale = true;
          }
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchSerialNumberList() {
      this.loading = true;
      const page = this.options.page || 1;
      const limit = this.options.itemsPerPage || 10; // Sayfa başına öğe sayısı
      const start = (page - 1) * limit;
      serialNumberService
        .list("stockmovements", {
          start: start,
          limit: limit,
          serial_number: this.serial_number, // Arama terimini de gönder
        })
        .then((response) => {
          if (response && response.data) {
            this.serialnumberList = response.data;
            this.totalItems = response.total; // Toplam öğe sayısını güncelle
          } else {
            console.error("Invalid response format:", response);
          }
        })
        .catch((error) => {
          console.error("Bir hata oluştu:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async addSerialNumber() {
      if (this.$refs.form.validate()) {
        // Formu doğrula
        try {
          await mainService.addSerialNumber(this.newSerialNumber); // Yeni kullanıcıyı ekle
          this.fetchSerialNumberList(); // Kullanıcı listesini güncelle
          this.addSerialNumberDialog = false; // Modalı kapat
          this.resetNewSerialNumber(); // Yeni kullanıcı formunu sıfırla
        } catch (error) {
          console.error("Kullanıcı eklenirken hata oluştu:", error);
        }
      }
    },
    updateSelectedCustomerId(event) {
      console.log(event);
      this.newSale.selectedCustomerId = event.target.value;
    },

    async makeFastSale() {
      if (this.newSale.selectedCustomerId == null) {
        this.isCustomerValidMessage = "Müşteri Seçilmedi";
        return;
      }
      if (this.newSale.selectedUserId == null) {
        this.isPersonalValidMessage = "Personel Seçilmedi";
        return;
      }
      if (this.newSale.sellingPrice == null) {
        this.isSellingPriceValidMessage = "Satış Fiyatı Girilmedi";
        return;
      }
      if (this.newSale.creditCard == null) {
        this.isCreditCardValidMessage = "Değer Girilmedi Örn:0";
        return;
      }

      if (this.$refs.form.validate()) {
        try {
          await mainService.add(this.newSale, "sale"); // Yeni stokyı ekle
          (this.isSerialNumberValid = false),
            (this.isSerialNumberValidMessage = "Seri No"),
            (this.fastSale = false);
          this.resetNewSale(); // Yeni stok formunu sıfırla
          this.fetchSerialNumberList();
        } catch (error) {
          console.error("Satışta hata oluştu:", error);
        }
      }
    },

    async deleteSerialNumber(SerialNumberId) {
      const { value: confirmDelete } = await Swal.fire({
        title: "Silmek istediğinize emin misiniz?",
        text: "Bu işlem geri alınamaz!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "Hayır, iptal et!",
      });

      if (confirmDelete) {
        try {
          await mainService.deleteSerialNumber(SerialNumberId); // Kullanıcıyı silmek için servisi çağır
          this.fetchSerialNumberList(); // Kullanıcı listesini güncelle
          Swal.fire("Silindi!", "Kullanıcı başarıyla silindi.", "success");
        } catch (error) {
          console.error("Kullanıcı silinirken hata oluştu:", error);
          Swal.fire("Hata!", "Kullanıcı silinirken bir hata oluştu.", "error");
        }
      } else {
        Swal.fire(
          "İptal edildi",
          "Kullanıcı silme işlemi iptal edildi.",
          "info"
        );
      }
    },
  },
  watch: {
    options: {
      handler() {},
      deep: true,
    },
    newSale: {
      handler(newVal) {
        console.log("Yeni Sale Değeri:", newVal);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
/* İsteğe bağlı stil ayarları */
.v-data-table {
  background-color: #ffffff;
  /* Beyaz arka plan */
  border-radius: 8px;
  /* Köşeleri yuvarla */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  /* Hafif gölge */
}

.icon-size {
  width: 30px;
  height: 30px;
}

.highlight-update {
  animation: highlightPrice 1.5s ease;
}

@keyframes highlightPrice {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: rgba(0, 255, 0, 0.2);
  }
  100% {
    background-color: transparent;
  }
}
</style>
